import { useAuthenticationContext } from '../Authentication/AuthenticationContext';

export function useTimezoneService() {

  const authenticationContext = useAuthenticationContext();

  const deviceTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const timezone = authenticationContext?.user.profile.timezone || deviceTimezone;

  const getTimezone = () => {
    return timezone;
  }

  return {
    getTimezone,
  };
}
